import type { UseMediaCAllBack } from './useMedia'
import { useMedia } from './useMedia'

export function useMediaLess(maxWidthPx: number, callback?: UseMediaCAllBack) {
  return useMedia(`(max-width: ${maxWidthPx}px)`, callback)
}
